export default __webpack_public_path__ + "static/media/cladding32.1c24c891.jpeg";